import {makeEnumTypeGuard} from '../typescript/enumHelpers';

export enum FrontEnvironmentsEnum {
  PRODUCTION = 'production',
  STAGING = 'staging',
  NETLIFY = 'netlify',
  DEVELOPMENT = 'development',
}

export const isFrontEnvironment = makeEnumTypeGuard(FrontEnvironmentsEnum);
